import { render } from "./QueryRegionSelector.vue?vue&type=template&id=56869078"
import script from "./QueryRegionSelector.vue?vue&type=script&lang=js"
export * from "./QueryRegionSelector.vue?vue&type=script&lang=js"

import "./QueryRegionSelector.vue?vue&type=style&index=0&id=56869078&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__